export default "__VITE_ASSET__CM0f8JcD__"